
import { validateBirthNumber } from '@/app/[locale]/order/_utils/validate-birth-number'

import { BIRTH_NUMBER_ERROR_MESSAGES, ERR } from './patient-form.constants'

import type { PatientFormValues } from '../_types/patient-form.types'
import type { RegisterOptions } from 'react-hook-form'

/**
 * RHF registration options for the birth number field (masking + SK validation, optional when EU insurer).
 */
export function getBirthNumberRegisterOptions(
	isEUInsurance: boolean
): RegisterOptions<PatientFormValues, 'birthNumber'> {
	return {
		required: !isEUInsurance ? ERR.birthNumber.required : false,
		pattern: {
			value: /^\d{6}\/\d{3,4}$/,
			message: ERR.birthNumber.invalid
		},
		validate: value => {
			if (isEUInsurance) return true
			const result = validateBirthNumber(value)
			return result.isValid || BIRTH_NUMBER_ERROR_MESSAGES[result.errorCode]
		},
		onChange: e => {
			let v = e.target.value.replace(/\D/g, '')
			if (v.length > 6) v = v.slice(0, 6) + '/' + v.slice(6)
			if (v.length > 11) v = v.slice(0, 11)
			e.target.value = v
		}
	}
}
